module.exports = __webpack_public_path__ + "img/icon_over_manejo_escuelas.8741e429.svg";